import { useMemo } from 'react';

import * as aiPersonalizationApi from '../services/aiPersonalizationApi';

// Web's implementation of @copilot/ui's AiPersonalizationApi. Stable for the
// component's lifetime (a new object would make the shared section reload).
// httpClient's errors carry the backend's `code`, which the section maps to
// its own messages.
export function useAiPersonalizationApi() {
  return useMemo(
    () => ({
      getAiStyles: () => aiPersonalizationApi.getAiStyles(),
      getCustomProfiles: () => aiPersonalizationApi.getCustomProfiles(),
      getCustomProfile: (id) => aiPersonalizationApi.getCustomProfile(id),
      createCustomProfile: (body) => aiPersonalizationApi.createCustomProfile(body),
      updateCustomProfile: (id, body) => aiPersonalizationApi.updateCustomProfile(id, body),
      duplicateCustomProfile: (id, body) => aiPersonalizationApi.duplicateCustomProfile(id, body),
      deleteCustomProfile: (id) => aiPersonalizationApi.deleteCustomProfile(id),
      getAiSelection: () => aiPersonalizationApi.getAiSelection(),
      saveAiSelection: (body) => aiPersonalizationApi.saveAiSelection(body),
      clearAiSelection: () => aiPersonalizationApi.clearAiSelection(),
      errorCode: (error) => (error && typeof error.code === 'string' ? error.code : undefined),
    }),
    []
  );
}
